import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { tap, map, Observable, of } from 'rxjs';
import { User } from 'src/app/data/model/user';
import { TotpDeviceApiService } from 'src/app/shared/api/services/totp-device-api.service';
import { DialogsService } from 'src/app/shared/dialogs/dialogs-service';

@Component({
  standalone: false,
  selector: 'app-register-totp-device-dialog',
  templateUrl: './register-totp-device-dialog.component.html',
  styleUrls: ['./register-totp-device-dialog.component.scss']
})
export class RegisterTotpDeviceDialogComponent {

  constructor(
    private formBuilder: FormBuilder,
    public sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    protected dialogsService: DialogsService,
    private apiService: TotpDeviceApiService,
    public dialogRef: MatDialogRef<RegisterTotpDeviceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: User }
  ) {}

 

  static error: ValidationErrors;
  showOTPForm = false;



  entityFormGroup: FormGroup= this.formBuilder.group({
    name:this.data.user.username,
  });

  otpFormGroup: FormGroup= this.formBuilder.group({
    otp_code: [null, [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
  });

  generateOtp2() {
    this.entityFormGroup.markAllAsTouched();

    if (this.entityFormGroup.valid){
      this.apiService.setupOTP(this.entityFormGroup.value).subscribe(
        (response) => {
          this.showOTPForm = true;
        },
        (error) => {
          console.log(error);
        }
      )
    } else {
      Object.keys(this.entityFormGroup.controls).forEach(key => {
        const controlErrors = this.entityFormGroup.get(key)?.errors;
        console.log(key, controlErrors); // Logs the control name and its errors
      });
    }
  }
  qrImageUrl: SafeUrl | null = null;

  generateOtp() {
    this.entityFormGroup.markAllAsTouched();
  
    if (this.entityFormGroup.valid) {
      this.apiService.setupOTP(this.entityFormGroup.value).subscribe(
        (response: any) => {
          this.qrImageUrl = this.sanitizer.bypassSecurityTrustUrl(
            URL.createObjectURL(response));
          this.showOTPForm = true;
        },
        (error) => {
          if (error.error='"no_unconfirmed_device"') {
            this.generateOtp2();
          }
          console.error(error);
        }
      );
    }
  }

  clodeDialog(){
    this.dialogRef.close();
  }

  confirmOtp() {
    this.otpFormGroup.markAllAsTouched();

    if (this.otpFormGroup.valid){
      this.apiService.confirmOtp(this.otpFormGroup.value).subscribe(
        (response) => {
          this.showConfirmMessage();
          this.dialogRef.close();
        },
        (error) => {
          if (error.error='no_unconfirmed_device') {
            this.showConfirmMessage();
            this.dialogRef.close();
          }
          console.log(error);
        }
      )
    } else {
      Object.keys(this.otpFormGroup.controls).forEach(key => {
        const controlErrors = this.otpFormGroup.get(key)?.errors;
        console.log(key, controlErrors); // Logs the control name and its errors
      });
    }
  }

  deleteMessage(): Observable<string> {
    return of("Sei sicuro di voler disabilitare l'otp?");
  }

  showConfirmMessage() {
    this.snackBar.open('OTP attivato', 'Chiudi', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-success"]
    });
  }

  showSuccessMessage() {
    this.snackBar.open('OTP disabilitato', 'Chiudi', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-success"]
    });
  }

  showFailMessage() {
    this.snackBar.open('OTP non disabilitato', 'Chiudi', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-fail"]
    });
  }



  disableOtp() {
    this.deleteMessage()
      .pipe(
        tap((message) =>
          this.dialogsService
            .cancelConfirm$({ message })
            .pipe(
              map(() => {
                //this.loading$=true;
                this.apiService.disableOtp().subscribe(
                  (response) => {
                    this.showSuccessMessage();
                    this.dialogRef.close();
                  },
                  (error)=>{
                    this.showFailMessage();
                    console.log(error);
                  }
                );
              })
            )
            .subscribe()
        )
      )
      .subscribe();
  }

}
